export const FilterIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.49784 13.75C8.33668 13.75 8.17987 13.6988 8.05095 13.6041L5.05527 11.4149C4.96276 11.3469 4.88768 11.2588 4.83597 11.1574C4.78426 11.0561 4.75734 10.9444 4.75734 10.8311V8.15297L0.54238 2.57784C0.378263 2.36064 0.278919 2.10307 0.255418 1.83381C0.231916 1.56455 0.28518 1.29419 0.409275 1.05285C0.53337 0.811506 0.723421 0.608657 0.958256 0.466904C1.19309 0.325151 1.46348 0.250061 1.73931 0.25H12.2607C12.5365 0.250061 12.8069 0.325151 13.0417 0.466904C13.2766 0.608657 13.4666 0.811506 13.5907 1.05285C13.7148 1.29419 13.7681 1.56455 13.7446 1.83381C13.7211 2.10307 13.6217 2.36064 13.4576 2.57784L9.24266 8.15297V13.0203C9.24266 13.2138 9.16419 13.3994 9.02451 13.5363C8.88483 13.6731 8.69538 13.75 8.49784 13.75ZM6.24698 10.4662L7.75302 11.5659V7.91216C7.75302 7.75427 7.80529 7.60064 7.90198 7.47432L12.2607 1.70946H1.73931L6.101 7.47432C6.19769 7.60064 6.24996 7.75427 6.24996 7.91216L6.24698 10.4662Z" />
    </svg>
  )
}
